// extracted by mini-css-extract-plugin
module.exports = {"content":"Main_content__tmr5D","active":"Main_active__I93Y2"};